import { Tooltip } from "antd";
import classNames from "classnames";
import { DEFAULT_PLACEMENT_TOOLTIP } from "config/consts";
import { RequestHistory } from "models/RequestHistory";
import React, { ReactNode } from "react";
import {
  CompareState,
  HISTORY_STATE_TYPE,
  requestHistoryService,
} from "services/page-services/request-history-service";
import "./HistoryContent.scss";

interface HistoryContentProps {
  content: RequestHistory;
  oldContent: RequestHistory;
  fieldName: string;
  renderContent?: ReactNode;
  renderOldContent?: ReactNode;
  className?: string;
  type?: HISTORY_STATE_TYPE;
  showTooltip?: boolean;
  textClassname?: string;
  index?: number;
}

function HistoryContent(props: HistoryContentProps) {
  const {
    renderContent,
    renderOldContent,
    content,
    oldContent,
    fieldName,
    className,
    type,
    textClassname,
    showTooltip,
  } = props;

  const compareState: CompareState = React.useMemo<CompareState>(() => {
    const compareState =
      type === "check"
        ? requestHistoryService.useCompareHistoryRequest(
          fieldName,
          content,
          oldContent
        )
        : null;
    return compareState;
  }, [content, fieldName, oldContent, type]);

  return (
    <div className={classNames("history-content__container", className)}>
      {type === "check" && (
        <>
          <span
            className={classNames(textClassname, {
              "diff-added":
                compareState === CompareState.GREEN ||
                compareState === CompareState.RED,
            })}
          >
            {showTooltip ? (
              <Tooltip
                placement={DEFAULT_PLACEMENT_TOOLTIP}
                title={
                  <div className="default__tooltip__title">
                    {renderContent ? renderContent : ""}
                  </div>
                }
              >
                {renderContent ? renderContent : ""}
              </Tooltip>
            ) : (
              <> {renderContent ? renderContent : ""} </>
            )}
          </span>
          {compareState === CompareState.RED ? (
            <span className={classNames(textClassname, "diff-removed")}>
              {showTooltip ? (
                <Tooltip
                  placement={DEFAULT_PLACEMENT_TOOLTIP}
                  title={
                    <div className="default__tooltip__title">
                      {renderOldContent ? renderOldContent : ""}
                    </div>
                  }
                >
                  {renderOldContent ? renderOldContent : ""}
                </Tooltip>
              ) : (
                <>{renderOldContent ? renderOldContent : ""}</>
              )}
            </span>
          ) : null}
        </>
      )}

      {type === "add" && (
        <>
          <span className={classNames(textClassname, "diff-added")}>
            {showTooltip ? (
              <Tooltip
                placement={DEFAULT_PLACEMENT_TOOLTIP}
                title={
                  <div className="default__tooltip__title">
                    {renderContent ? renderContent : ""}
                  </div>
                }
              >
                {renderContent ? renderContent : ""}
              </Tooltip>
            ) : (
              <>{renderContent ? renderContent : ""}</>
            )}
          </span>
        </>
      )}
      {type === "remove" && (
        <>
          <span className={classNames(textClassname, "diff-removed")}>
            {showTooltip ? (
              <Tooltip
                placement={DEFAULT_PLACEMENT_TOOLTIP}
                title={
                  <div className="default__tooltip__title">
                    {renderOldContent ? renderOldContent : ""}
                  </div>
                }
              >
                {renderOldContent ? renderOldContent : ""}
              </Tooltip>
            ) : (
              <>{renderOldContent ? renderOldContent : ""}</>
            )}
          </span>
        </>
      )}
    </div>
  );
}

HistoryContent.defaultProps = {
  type: HISTORY_STATE_TYPE.CHECK,
  textClassname: "history-content__text",
  showTooltip: false,
};

export default HistoryContent;
